module.exports = __webpack_public_path__ + "d8988f687ccd0e8885bea743dc63cd43.svg";